import React from "react";
import { func } from "prop-types";
import Button from "./Button";

const FilterTags = ({ openSideBarFilters }) => (
    <div className="tags-filter">
        <Button
            image="images/figma/icon/filter.svg"
            onClick={openSideBarFilters}
            label="global.filter"
            className="btn btn-link open-filters"
            block={false}
        />
    </div>
);
FilterTags.propTypes = {
    openSideBarFilters: func.isRequired,
};
export default FilterTags;
